export const INSTRUCTOR_DOCUMENT_SECTIONS = ['Insurance', 'Certifications', 'Other'];

export const normalizeInstructorDocumentCategory = (category) => {
  const normalized = String(category || '').trim().toLowerCase();

  if (normalized === 'insurance') return 'Insurance';
  if (normalized === 'certification' || normalized === 'certifications') return 'Certifications';

  return 'Other';
};

export const buildInstructorDocumentEntry = ({
  url,
  category,
  fileName,
  notes,
  uploadedBy,
  date = Date.now(),
}) => ({
  Date: date,
  URL: url,
  Category: normalizeInstructorDocumentCategory(category),
  fileName: fileName || '',
  Notes: notes || '',
  UploadedBy: uploadedBy || '',
});

export const waitForInstructorDocumentUpload = (uploadTask, onProgress = () => {}) => (
  new Promise((resolve, reject) => {
    uploadTask.on(
      'state_changed',
      (snapshot) => {
        const totalBytes = Number(snapshot?.totalBytes || 0);
        const bytesTransferred = Number(snapshot?.bytesTransferred || 0);
        const progress = totalBytes > 0 ? Math.round((bytesTransferred / totalBytes) * 100) : 0;
        onProgress(progress);
      },
      reject,
      resolve
    );
  })
);

export const normalizeInstructorDocuments = (documents) => {
  const documentArray = Array.isArray(documents)
    ? documents
    : documents && typeof documents === 'object'
      ? Object.values(documents)
      : [];

  return documentArray
    .filter((document) => document && typeof document === 'object' && !Array.isArray(document))
    .map((document, index) => ({
      ...document,
      _documentIndex: Number.isInteger(document._documentIndex) ? document._documentIndex : index,
    }));
};

export const formatInstructorDocumentDate = (dateValue) => {
  if (!dateValue) return 'No date recorded';

  const date = dateValue?.toDate ? dateValue.toDate() : new Date(dateValue);
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return 'No date recorded';

  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  }).format(date);
};

export const groupInstructorDocuments = (documents = []) => {
  const grouped = INSTRUCTOR_DOCUMENT_SECTIONS.reduce((acc, section) => {
    acc[section] = [];
    return acc;
  }, {});

  normalizeInstructorDocuments(documents).forEach((document) => {
    const category = normalizeInstructorDocumentCategory(document?.Category);
    grouped[category].push(document);
  });

  return grouped;
};
